// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3vd4m","modalFooterButton":"ModalNotes_modalFooterButton__2bOK_"};